import React from "react";

interface SocialMediaLink {
  name: string;
  logoUrl: string;
}

interface Props {
  links: SocialMediaLink[];
}

const SocialMediaLinks: React.FC<Props> = ({ links }) => {
  if (!links || links.length === 0) return null;

  return (
    <div className="social-media-container">
      {links.map((link) => (
        <a key={link.name} href="#" className="social-icon" title={link.name}>
          <img src={link.logoUrl} alt={link.name} />
        </a>
      ))}
    </div>
  );
};

export default SocialMediaLinks;
